import type { IconProps } from './types';

export const BulletListIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19.3627 17.9321L19.2856 17.9282H9.57172C9.15764 17.9282 8.82194 18.2641 8.82172 18.6782C8.82172 19.0924 9.1575 19.4282 9.57172 19.4282H19.2856L19.3627 19.4242C19.7407 19.3857 20.0356 19.0664 20.0356 18.6782C20.0354 18.2901 19.7407 17.9706 19.3627 17.9321Z"
        fill={color}
      />
      <path
        d="M19.3627 11.2543L19.2856 11.2504H9.57172C9.1575 11.2504 8.82172 11.5862 8.82172 12.0004C8.82194 12.4144 9.15764 12.7504 9.57172 12.7504H19.2856L19.3627 12.7465C19.7407 12.708 20.0354 12.3885 20.0356 12.0004C20.0356 11.6122 19.7407 11.2929 19.3627 11.2543Z"
        fill={color}
      />
      <path
        d="M19.3627 4.57561L19.2856 4.57171H9.57172C9.1575 4.57171 8.82172 4.90749 8.82172 5.32171C8.82187 5.73579 9.1576 6.07171 9.57172 6.07171H19.2856L19.3627 6.0678C19.7407 6.02927 20.0354 5.7098 20.0356 5.32171C20.0356 4.9335 19.7408 4.61418 19.3627 4.57561Z"
        fill={color}
      />
      <path
        d="M19.3627 4.57561L19.2856 4.57171H9.57172C9.1575 4.57171 8.82172 4.90749 8.82172 5.32171C8.82187 5.73579 9.1576 6.07171 9.57172 6.07171H19.2856L19.3627 6.0678C19.7407 6.02927 20.0354 5.7098 20.0356 5.32171C20.0356 4.9335 19.7408 4.61418 19.3627 4.57561Z"
        fill={color}
      />
      <path
        d="M5.32172 20.0356C6.07115 20.0354 6.67816 19.4275 6.67816 18.6782C6.67795 17.9758 6.14453 17.3981 5.46039 17.3285L5.32172 17.3217C4.61911 17.3217 4.04078 17.8554 3.97113 18.5395L3.96429 18.6782L3.97113 18.8178C4.04084 19.5019 4.61916 20.0356 5.32172 20.0356Z"
        fill={color}
      />
      <path
        d="M5.32172 13.3569C6.07097 13.3567 6.67794 12.7497 6.67816 12.0004C6.67816 11.2978 6.14464 10.7194 5.46039 10.6498L5.32172 10.643C4.61919 10.643 4.04084 11.1766 3.97113 11.8608L3.96429 12.0004L3.97113 12.1391C4.04077 12.8233 4.61914 13.3569 5.32172 13.3569Z"
        fill={color}
      />
      <path
        d="M5.32172 6.67815C6.07102 6.678 6.67801 6.07101 6.67816 5.32171C6.67816 4.61909 6.14465 4.0407 5.46039 3.97112L5.32172 3.96429C4.61891 3.96429 4.04045 4.49851 3.97113 5.18304L3.96429 5.32171L3.97113 5.46038C4.04071 6.14464 4.61909 6.67815 5.32172 6.67815Z"
        fill={color}
      />
    </svg>
  );
};
